/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoUpdateCountry } from '../../models/dto-update-country';

export interface CountryControllerUpdate$Params {
  iso: string;
      body: DtoUpdateCountry
}

export function countryControllerUpdate(http: HttpClient, rootUrl: string, params: CountryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, countryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('iso', params.iso, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

countryControllerUpdate.PATH = '/country/{iso}';
